import { NAVY_D } from '@/lib/colors';

// `FooterLinks` + the per-group label fields are still in the type so the
// Page.tsx call sites compile unchanged; we just don't render them anymore.
// The 4-column nav grid was removed 2026-05-09 — most links were stubs and
// the visual weight was disproportionate for an early-stage product page.
export type FooterLinks = ReadonlyArray<readonly [string, string]>;

export type FooterLabels = {
  tagline: string;
  productHeader: string;
  productLinks: FooterLinks;
  companyHeader: string;
  companyLinks: FooterLinks;
  helpHeader: string;
  helpLinks: FooterLinks;
  legal: string;
  copyright: string;
};

export function Footer({ labels }: { labels: FooterLabels }) {
  return (
    <footer
      style={{
        background: NAVY_D,
        padding: '20px 24px',
        color: 'rgba(255,255,255,0.55)',
      }}>
      <div
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 10,
          fontSize: 12,
        }}>
        <span>© {new Date().getFullYear()} {labels.copyright}</span>
        <span>{labels.legal}</span>
      </div>
    </footer>
  );
}
